import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import {FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';

@Component({
  selector: 'lib-select-option',
  standalone: true,
  imports: [CommonModule,MatSelectModule,ReactiveFormsModule],
  templateUrl: './select-option.component.html',
  styleUrl: './select-option.component.scss',
   providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectOptionComponent),
      multi: true,
    },
  ],
})
export class SelectOptionComponent {
  @Input() formGroup!: FormGroup;
  @Input() formControlName!: string;
  @Input() optionData:any[] = [];
  @Input() submitted:boolean=false;
  @Input() placeHolderName!:String;


  value: any;
  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}
